export interface Achievement {
  title: string;
  description: string;
}

export const achievements: Achievement[] = [
  { title: '50% Transaction Volume Boost', description: 'Implemented high-performance solutions for financial systems' },
  { title: '90% Onboarding Time Reduction', description: 'Streamlined digital KYC integration processes' },
  { title: '40% Security Incident Reduction', description: 'Enhanced authentication and security protocols' },
];
